module.exports = new __parcel__URL__("rovo-icon.c02ccc2a.svg").toString();